import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { get } from '@utils/axios_api';
import { Checkbox } from '@components/form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp, faAngleDown } from '@fortawesome/free-solid-svg-icons';

function TermsItem({ term }) {
  const [open, setOpen] = useState(false);

  const { data: html = '' } = useQuery(
    ['termHtml', term.termsId],
    () => get(`/terms/${term.termsId}/html`, { responseType: 'text' }),
    { enabled: open }
  );

  return (
    <>
      <div className="agree-wrapper box-border" style={{ marginTop: '2rem' }}>
        <div className="checkbox-mr">
          <Checkbox
            label={`${term.title}${term.required ? ' (필수)' : ' (선택)'}`}
            name={`t${term.termsId}`}
            required={term.required}
            showError={false}
          />
        </div>

        <div
          className="btn-container"
          style={{ marginLeft: 'auto', cursor: 'pointer' }}
          onClick={() => setOpen(!open)}
        >
          <FontAwesomeIcon icon={open ? faAngleUp : faAngleDown} />
        </div>
      </div>

      {open && (
        <div
          className="agree"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      )}
    </>
  );
}

export default TermsItem;
